import { logLegacyImageUrl } from './legacyImageLogger';

// To view the available transforms go to:
// http://stackoverflow.com/questions/25148567/list-of-all-the-app-engine-images-service-get-serving-url-uri-options/35587365#35587365

export const LegacyPlaceholderBusinessImage =
  'https://storage.googleapis.com/tock-public-assets/placeholders/hero-placeholder-pattern.png';

const applyTransforms = (url: string | undefined, transformString: string) => {
  let finalUrl = url || '';

  /**
   * Hacky fix while we figure out why/how this is getting
   * into patron image_url fields. See TK-7160. CDM 02/24/21
   */
  if (finalUrl.endsWith('=s96-c')) {
    finalUrl = finalUrl.slice(0, finalUrl.length - 6);
  }

  if (finalUrl.indexOf('googleusercontent.com') > 0) {
    logLegacyImageUrl('applyTransforms', finalUrl);
    finalUrl = `${finalUrl}${transformString}`;
  }

  return finalUrl;
};

const legacySupportsWebp = () => BROWSER && window.supportsWebp;

const getFormat = (): string => {
  return legacySupportsWebp() ? '-rw' : '-rj';
};

export function legacyImageUrl(imageUrlInput: string | undefined, size = 1600) {
  return applyTransforms(imageUrlInput, `=s${size}-e7-v1${getFormat()}`);
}

export function legacyCropImageUrl(imageUrlInput: string | undefined, width: number, height: number) {
  return applyTransforms(imageUrlInput, `=e7-v1${getFormat()}-w${width}-h${height}-n`);
}

export function legacyCenterCropThumbnailUrl(imageUrlInput: string | undefined) {
  return legacyCropImageUrl(imageUrlInput, 576, 384);
}

export function legacyCenterCropThumbnailUrlSquare(imageUrlInput: string | undefined) {
  return legacyCropImageUrl(imageUrlInput, 100, 100);
}

export function legacyGuestImageUrl(imageUrlInput: string | undefined, size = 100) {
  return applyTransforms(imageUrlInput, `=s${size}-c-e7`);
}
